module.exports = __webpack_public_path__ + "static/media/purchase-icon_m.9242b447.jpg";